<script>
export const group = 'Full'
</script>

<script setup>
import ToFullTopLeft from './transitions/energetic_frequencies/ToFullTopLeft.vue'
import ThxToYouCounterContent from './thx_to_you_counter/ThxToYouCounterContent.vue'

defineProps({
  item: Object,
})
</script>

<template>
  <ToFullTopLeft>
    <ThxToYouCounterContent :item="item" />
  </ToFullTopLeft>
</template>
